import { makeStyles } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useStyles = makeStyles({
  progressBarWrapper: {
  },
  cumulativePointsProgressBarWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: customTokens.spacingVerticalXL,
    marginTop: customTokens.spacingVerticalL,
    paddingRight: customTokens.spacingHorizontalL,
    paddingBottom: customTokens.spacingVerticalL,
  },
});
